import { Flex, Text } from "@backstage/ui";

import styles from "./EmptyState.module.css";

export interface EmptyStateProps {
    centered: boolean;
}

export const EmptyState = ({ centered }: EmptyStateProps) => (
    <Flex
        align={centered ? "center" : "start"}
        justify="center"
        className={styles.container}
    >
        <Text
            as="p"
            variant="body-medium"
            color="secondary"
            className={styles.text}
        >
            Ask a question below to get started.
        </Text>
    </Flex>
);
